;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.product.show')
    .controller('ProductShowController', ProductShowController)

  ProductShowController.$inject = [
    // Angular
    '$state', '$scope', '$uibModal',

    // Managers
    'ProductManager', 'ClientConditionManager', 'CategoryManager',
    'ProductTypeManager', 'BpuManager',

    // Services
    'EntityService', 'SnackService', 'DisplayService', 'SessionService',
    'PreferencesService',

    // Resolve
    'product', 'vatList', 'categories'

  ]

  function ProductShowController (
    // Angular
    $state, $scope, $uibModal,

    // Managers
    ProductManager, ClientConditionManager, CategoryManager,
    ProductTypeManager, BpuManager,

    // Services
    EntityService, SnackService, DisplayService, SessionService,
    PreferencesService,

    // Resolve
    product, vatList, categories

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        product: product,
        vatList: vatList,
        categories: categories,
        bpus: [],
        lifo: false,
        productPrice: product.price?.amount,
        productVAT: product.VAT,
        // Methods
        remove: remove,
        save: save,
        getVatList: getVatList,
        getCategories: getCategories,
        categoryExists: categoryExists,
        addClientCondition: addClientCondition,
        removeClientCondition: removeClientCondition,
        searchBpu: searchBpu,
        openHistoryPrices: openHistoryPrices,
        setDirty: setDirty,
        getIsGrant: getIsGrant,
        checkPrice: checkPrice
      })
      init()
    }

    $scope.$on('formModified', function () {
      self.productForm.$dirty = true
    })

    function init () {
      PreferencesService.getProductPrefs().then(function (productPrefs) {
        self.productPrefs = productPrefs
      })
      self.userId = SessionService.getUser()
      PreferencesService.getCompanyPrefs().then((companyPrefs) => {
        self.requiredForExport = _.get(companyPrefs, 'enabledFeatures.requiredForExport')
      })
      ProductTypeManager.getAllByBatch(ProductTypeManager.query()).then(function (data) {
        self.types = data.data
      })
      self.saveCategory = false
      self.product.tags = self.product.tags || []
      self.product.history = self.product.history || []
      self.product.flags = self.product.flags || ['sufa']
      self.lifo = self.product.flags.includes('lifo')
    }
    function setDirty () {
      self.lifo = !self.lifo
      self.productForm.$dirty = true
    }

    function getCategories (search) {
      var newCategories = self.categories.slice()
      if (search && newCategories.indexOf(search) === -1) {
        newCategories.unshift(search)
      }
      return newCategories
    }

    function getIsGrant (type) {
      if (type.grant) {
        self.product.VAT = 0
      }
      self.product.grant = type.grant
    }

    function getVatList (search) {
      var newVats = self.vatList.slice()
      if (search && newVats.indexOf(search) === -1) {
        newVats.unshift(search)
      }
      return newVats
    }

    function categoryExists () {
      return _.includes(self.categories, product.category)
    }

    function save (product) {
      if (self.productPrice !== self.product.price.amount || self.productVAT !== self.product.VAT) {
        self.product.history.push({
          date: new Date(),
          amount: self.productPrice,
          user: self.userId,
          VAT: self.productVAT
        })
      }
      if (self.lifo && !self.product.flags.includes('lifo')) {
        self.product.flags.push('lifo')
      } else {
        self.product.flags = self.product.flags.filter(el => el !== 'lifo')
      }
      if (self.saveCategory) {
        CategoryManager.create({ label: product.category }).save()
      }
      self.product.grant = self.product.type?.grant
      product.save().then(function () {
        SnackService.snack({
          text: 'Produit sauvegardé !',
          delay: 5000
        })
        if ($state.is('product.new')) {
          if (self.productPrefs.redirect === 'new') $state.reload()
          else $state.go('product.list')
        } else {
          self.loading = false
          $state.reload()
        }
      })
    }

    function removeClientCondition (index) {
      self.product.clientConditions = self.product.clientConditions || []
      self.product.clientConditions.splice(index, 1)
    }

    function addClientCondition () {
      EntityService.prompt().then(function (data) {
        self.product.clientConditions = self.product.clientConditions || []
        self.selectedConditions = ClientConditionManager.create({
          client: data,
          price: _.clone(self.product.price),
          VAT: self.product.VAT,
          label: self.product.label,
          unit: self.product.unit
        })
        self.product.clientConditions.push(self.selectedConditions)
      })
    }

    function remove () {
      DisplayService.confirmDeletion().then(function () {
        product.archive().then(function () {
          SnackService.snack({
            text: 'Produit supprimé',
            delay: 5000,
            action: self.product.restore(),
            actionText: 'Annuler'
          })
          $state.go('product.list')
        })
      })
    }

    function searchBpu (search) {
      var query = BpuManager.query({
        populate: JSON.stringify([
          {
            path: 'client'
          }
        ])
      })
        .search(search, 'label')
      return BpuManager.get(query)
        .then(function (data) {
          self.bpus = data.data
          return data.data
        })
    }

    function checkPrice () {
      if (self.product.type?.grant) {
        self.product.price.amount = self.product.price.amount <= 0 ? self.product.price.amount : -self.product.price.amount
      }
    }

    function openHistoryPrices () {
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/product/show/controllers/modals/history-price/history-price-modal.template.html',
        resolve: {
          history: [() => {
            return self.product.history
          }]
        },
        controller: 'HistoryPriceModalController',
        controllerAs: '$ctrl'
      }).result.then((elt) => {
        self.product.history.push({
          date: new Date(),
          amount: self.product.price.amount,
          user: self.userId,
          VAT: self.product.VAT
        })
        self.product.price.amount = elt.amount
        self.product.VAT = elt.VAT
        self.product.save().then(() => {
          SnackService.snack({
            text: 'Prix modifié !',
            delay: 3000
          })
          $state.reload()
        })
      })
    }
  }
})(window.angular, window._)
